import React, { FC } from 'react';
import { OptionGroup, Option } from '../OptionGroup';

interface IBooleanOptionGroupProps {
  customClassname?: string;
  onClick: (value: boolean) => void;
  value?: boolean;
  customIdBase: string;
  readOnly?: boolean;
  leftLabel?: string;
  rightLabel?: string;
  disableRight?: boolean;
  disableLeft?: boolean;
  itemsPerRow?: number;
}
export const BooleanOptionGroup: FC<IBooleanOptionGroupProps> = ({
  customClassname,
  customIdBase,
  onClick,
  value,
  readOnly = false,
  disableRight = false,
  disableLeft = false,
  leftLabel = 'Yes',
  rightLabel = 'No',
  itemsPerRow,
}) => {
  const getTooltip = (key: string) => {
    const tooltipList: { [key: string]: string } = {
      "managed_dia_yes": 'Our Managed DIA service gives all the same great benefits as DIA, but we fully manage and monitor you connectivity, along with providing technical support 24/7 with a 5 hour hardware break fix SLA',
      "routing-option_yes": '2 resilient circuits configured using BGP. Each circuit will be allocated a /31 address for the WAN, a routed subnet will then be provided for use across both services along with a private AS allocation to enable BGP configuration. Customer is responsible for any routing failover between the 2 circuits. For any other configuration requirements, please contact your account manager.',
      "routing-option_no": '2 resilient circuits with individual IP address ranges assigned to each. Customer is responsible for any routing failover between the 2 circuits.',
    }
    return tooltipList[key] || '';
  }

  const options: Option<boolean>[] = [
    {
      customId: `${customIdBase}_yes`,
      label: leftLabel,
      value: true,
      disabled: readOnly || disableLeft,
      tooltip: getTooltip(`${customIdBase}_yes`)
    },
    {
      customId: `${customIdBase}_no`,
      label: rightLabel,
      value: false,
      disabled: readOnly || disableRight,
      tooltip: getTooltip(`${customIdBase}_no`)
    },
  ];

  const handleClick = (value: unknown) => {
    if (typeof value === 'boolean' && !readOnly) {
      onClick(value);
    }
  };

  return (
    <OptionGroup
      options={options}
      onClick={handleClick}
      value={value}
      customClassName={customClassname}
      readOnly={readOnly}
      itemsPerRow={itemsPerRow}
    />
  );
};
